import * as z from "zod/v4";

export const getWorkOrderViewCounts = {
  name: "getWorkOrderViewCounts" as const,
  input: z.null(),
  output: z.object({
    viewCounts: z.record(z.string(), z.number()),
    folderCounts: z.record(z.string(), z.number()),
  }),
};
